<template>
    <div>  
         <div class="news-list widget" v-if="news.length > 0">
            <div class="widget-title" :style="{background:feedData.color}">
                <img :alt="$t('home.widget.feed.'+feedData.type+'.text')" :src="feedData.icon"/> 
                {{ $t("home.widget.feed."+feedData.type+".text") }}
            </div>
            <ul>
                <li v-for="item in news" :key="item.message">
                    <article>
                        <a :href="item.link" target="_blank">
                            <div class="media">
                                <img v-if="item.enclosure" :src="item.enclosure.url" />
                            </div>
                            <div class="content">
                                <div class="article-title">{{item.title}}</div>
                                <p>{{item.content}}</p>
                                <div class="time">{{item.pubDate | formatDate}} {{item.pubDate | formatHour}}</div>
                            </div>
                        </a>
                    </article>
                </li>
            </ul>
            <div class="loading" v-if="loading">
                <b-spinner label="Loading..."></b-spinner>
            </div>
         </div>
    </div>
</template>

<script>
    export default {
        name: "NewsListWidget",
        props: {
            news: Array,
            feedData: Object,
            loading: Boolean
        }
    }
</script>

<style scoped>
.widget {
    position: relative;
}
.news-list.widget .widget-title {
    padding: 8px 15px;
    padding-left: 5px;
    position: relative;
    font-size: 20px;
    font-weight: bold;
    background:  #2459a0;
    color: #fff;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}
.news-list.widget .widget-title img {
    width: 45px;
    margin-right: 5px;
}
.news-list.widget li {
    clear: both;
    margin-bottom: 15px;
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid #8f8f8f;
}
.news-list.widget article {
    width: 100%;
    position: relative;
}
.news-list.widget .media {
    float: left;
    width: 100%;
}
.news-list.widget .media img {
    width: 100%;
    height: initial;
}
.news-list.widget .content {
    display: inline-block;
    flex-direction: column;
}
.news-list.widget .content .article-title {
    color: #2459a0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    margin: 10px 0;
}
.news-list.widget .content p {
    color: #2459a0;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
}
.news-list.widget .content .time {
    color: #8f8f8f;
    float: right;
    margin-top: 10px;
    font-size: 14px;
}

#widget .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  } 

@media (min-width: 768px){
    .news-list.widget .media { 
        width: 150px;
        margin-right: 10px;
    }
    .news-list.widget .media img {
        width: 100%;
        height: initial;
    }
    .news-list.widget .content {
        display: flex;
        padding-bottom: 20px;
    }
    .news-list.widget .content .article-title {
        margin: 0;
    }
    .news-list.widget .content .time {
        float: initial;
        margin: 0;
        position: absolute;
        bottom: 0;
        right: 0;
    }
}

</style>

